export const app = {
  Storage: "STORAGE",
  Sales: "SALES",
  Calendar: "CALENDAR",
  Auth: "AUTH",
  Login: "LOGIN"
}
